import { Component } from '@angular/core';
declare let $: any;

@Component({
  selector: 'picker-menu',
  templateUrl: './picker-menu.component.html',
  styleUrls: ['./picker-menu.component.css'],
})
export class PickerMenuComponent {
  ngAfterViewInit() {
    $('.collapsible').collapsible();
  }
}
